import axios from 'axios'
import appconst from './appconst'
import Vue from 'vue'
const ajax = axios.create({


    baseURL: appconst.remoteServiceBaseUrl,
    timeout: 30000
});
ajax.interceptors.request.use(function (config) {
    if(!!window.abp.auth.getToken()){
        config.headers.common["Authorization"]="Bearer "+window.abp.auth.getToken();
    }
    config.headers.common[".AspNetCore.Culture"]=window.abp.utils.getCookieValue("Abp.Localization.CultureName");
    config.headers.common["Abp.TenantId"]=window.abp.multiTenancy.getTenantIdCookie();
    return config;
  }, function (error) {
    
    return Promise.reject(error);
});
let vm=new Vue({});
ajax.interceptors.response.use((respon) => {    
    const headers = respon.headers;
    if (headers['content-type'] === 'application/octet-stream;charset=utf-8') {
        return respon.data;
    }
    return respon;
}, (error) => {
    if (!!error.response && !!error.response.data.error && !!error.response.data.error.message && error.response.data.error.details) {
        setTimeout(() => {
            vm.$Modal.error({ title: error.response.data.error.message, content: error.response.data.error.details })
        }, 500);
    } else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message) {
        setTimeout(() => {
            vm.$Modal.error({ title: window.abp.localization.localize("业务错误："), content: error.response.data.error.message })
        }, 500);
    } else if (!error.response) {
        setTimeout(() => {
            vm.$Modal.error(window.abp.localization.localize('未知错误'));
        }, 500);
    }
    setTimeout(()=>{
       vm.$Message.destroy();
    },1000);
    return Promise.reject(error);
})
export default ajax;